<div class="pagination-container">
    <span>{{currentPage}} of {{totalPages}} Pages</span>
    <button [disabled]="currentPage===1" (click)="onPageChange(currentPage-1)" title="Previous page"><</button>
    <button [disabled]="currentPage===totalPages" (click)="onPageChange(currentPage+1)" title="Next page">></button>
</div>